import { render, staticRenderFns } from "./AddBooks.vue?vue&type=template&id=5b80a822&scoped=true"
import script from "./AddBooks.vue?vue&type=script&lang=js"
export * from "./AddBooks.vue?vue&type=script&lang=js"
import style0 from "./AddBooks.vue?vue&type=style&index=0&id=5b80a822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80a822",
  null
  
)

export default component.exports